import { configureStore } from '@reduxjs/toolkit'
import dashboardReducer from './reducerSlices'

export const store = configureStore({
    reducer: {
        dashboard_Reducer: dashboardReducer
    }
})
